module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-flags"
  }, [_vm._v("\n\n    " + _vm._s(_vm.$t('page.roster.tools.application')) + "\n\n    "), _c('br'), _c('br'), _vm._v(" "), _c('action', {
    attrs: {
      "icon": "check",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.allow.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.confirm')))]), _vm._v(" "), _c('action', {
    attrs: {
      "icon": "cancel",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deny.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.deny')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618ba907","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Flags.vue
// module id = 606
// module chunks = 234